import Season from './season';
import './season.scss';

export default Season;